import { createFileRoute } from "@tanstack/react-router";
import { TopHeader } from "@/components/TopHeader";
import { BottomNavigation } from "@/components/BottomNavigation";
import { VERIFICATION_STATUSES } from "@/lib/mock-data";
import { VerificationBadge } from "@/components/StatusBadge";

export const Route = createFileRoute("/verification-info")({
  head: () => ({
    meta: [
      { title: "Verification on Landoo" },
      { name: "description", content: "How Landoo verifies partners, customers and properties." },
      { property: "og:title", content: "Verification on Landoo" },
      {
        property: "og:description",
        content: "How Landoo verifies partners, customers and properties.",
      },
    ],
  }),
  component: VerifPage,
});

function VerifPage() {
  const steps = [
    "Aadhaar / government ID",
    "Driving licence (optional)",
    "PAN",
    "Selfie capture",
    "Video verification",
    "Live video call verification",
    "Property live verification",
    "Ownership declaration",
    "VAO / local authority certificate (optional)",
    "Signed legal agreement",
  ];
  return (
    <div className="flex min-h-screen flex-col bg-cream/30 pb-20 md:pb-0">
      <TopHeader />
      <main className="mx-auto w-full max-w-3xl flex-1 space-y-6 p-4 md:p-6">
        <div>
          <h1 className="text-2xl font-bold text-brown-dark">Trust & verification</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Landoo uses layered verification to keep listings genuine. Requirements vary by listing
            type (house rent, house lease, land sale, commercial, broker, owner).
          </p>
        </div>

        <section className="rounded-2xl border border-border bg-card p-4 shadow-soft">
          <h2 className="mb-3 text-base font-bold text-brown-dark">Verification statuses</h2>
          <div className="flex flex-wrap gap-2">
            {VERIFICATION_STATUSES.map((s) => (
              <VerificationBadge key={s} status={s} />
            ))}
          </div>
        </section>

        <section className="rounded-2xl border border-border bg-card p-4 shadow-soft">
          <h2 className="mb-3 text-base font-bold text-brown-dark">Verification steps</h2>
          <ol className="space-y-2 text-sm text-brown-dark">
            {steps.map((s, i) => (
              <li key={s} className="flex items-start gap-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-soft text-[11px] font-bold text-brown-dark">
                  {i + 1}
                </span>
                {s}
              </li>
            ))}
          </ol>
          <p className="mt-4 rounded-xl border border-dashed border-border bg-cream/50 p-3 text-xs text-muted-foreground">
            Full title documents are not required at this stage. Document requirements adapt per
            listing type.
          </p>
        </section>
      </main>
      <BottomNavigation />
    </div>
  );
}
